import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CierreSemanalService {

  constructor(
    public _http: HttpClient
  ) { }

  cierreSemanal(request : any): Observable<any> {
    let ruta = environment.cierreSemanal;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.put(ruta, params, { headers: headersResp });
  }
}
